<script lang="tsx">
import { computed, defineComponent, type PropType } from 'vue'
import { createNamespace, isObject } from '@bd/vue3-utils'
import { useCurrentSelect } from './useSelect'
import { Tag } from '-/Common/Tag'
const [name, bem] = createNamespace('TableSelectCurrent')
export default defineComponent({
  name,
  props: {
    nameKey: {
      type: String as PropType<string>,
      default: 'name'
    }
  },
  emits: ['close'],
  setup(props, { emit, slots }) {
    const options = useCurrentSelect()
    const isEmtpy = computed(() => !options!.value?.length)
    const renderSelects = () => (
      <div class={bem('tags')}>
        {slots?.current?.({ options: options!.value }) ??
          options!.value?.map(item => (
            <Tag key={item?.[props.nameKey] ?? item} type='info' closable onClose={() => emit('close', item)}>
              {isObject(item) ? item?.[props.nameKey] : item}
            </Tag>
          ))}
      </div>
    )
    const renderEmpty = () => <span class={bem('empty')}>暂未选择</span>
    return () => (
      <div class={bem()}>
        <label>当前选择：</label>
        {isEmtpy.value ? renderEmpty() : renderSelects()}
      </div>
    )
  }
})
</script>
<style lang="less">
.table-select-current {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 24px;

  label {
    padding-right: 10px;
    white-space: nowrap;
  }

  &__tags {
    line-height: 0;
  }

  &__empty {
    color: @disabled-color;
  }
}
</style>
